import { EGetOffersStatus } from './types';
import { actionGenerator } from '../../redux/actionGenerator';
import { fetchOffers } from '../../services/fetchOffers';
import { TOffers } from '../../types/offers';
import { TThunkAction } from '../../types/redux';

const setStatusLoading = actionGenerator<EGetOffersStatus.Loading>(EGetOffersStatus.Loading);
const setStatusSucceed = actionGenerator<EGetOffersStatus.Succeed, TOffers>(EGetOffersStatus.Succeed);
const setStatusFailed = actionGenerator<EGetOffersStatus.Failed>(EGetOffersStatus.Failed);

export function getOffers(text: string): TThunkAction<Promise<TOffers>> {
  return async (dispatch, getState, context) => {
    dispatch(setStatusLoading());

    const offersResponse = await fetchOffers(context, { text });
    if (offersResponse.status === 'succeed') {
      dispatch(setStatusSucceed(offersResponse.offers));
    } else {
      dispatch(setStatusFailed());
    }

    return offersResponse.offers;
  };
}
